import { FacetsGroupConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { SEARCH_ACTIONS_KEYS, SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class ResetFacetsCollapseAction implements SearchAction {

  actions = {
    [SEARCH_ACTIONS_KEYS.resetFacetsCollapse]: ({ dispatch, commit, state, rootGetters }: SearchContext, facetGroup: string) => {
      const facetGroupConfig: FacetsGroupConfig = rootGetters[GETTERS_KEYS.config.facetsGroups][facetGroup];
      Object.entries(facetGroupConfig.facets).forEach(([facetName, facet]) => {
        if (facet.collapsible) {
          const collapsed = facet.startCollapsed;
          commit(SEARCH_MUTATIONS_KEYS.setFacetCollapse, { facetGroup, facetName, collapsed });
        }
      });
    }
  };
}
